// @ts-nocheck
import { useEffect, useRef } from 'react'
import { CONSTANTS } from 'utils/constants'
import { onLocationPermissionDenied, isMobileApp } from 'utils/utils'

import MobileApplication from 'mobx/MobileApplication'

// This hook should be dependent on MobileApplication mobx userLocationPermissionStatus param, that every call for user location we change the status of
export const useLocationMobileApp = (onSuccess) => {
	const isFirstRender = useRef(true)

	useEffect(() => {
		const handleUserLocationPermissionResponse = async () => {
			if (MobileApplication.userLocationPermissionStatus === CONSTANTS.MOBILE_APP.PERMISSIONS.LOCATION.DENIED) {
				onLocationPermissionDenied()
			} else if (MobileApplication.userLocationPermissionStatus === CONSTANTS.MOBILE_APP.PERMISSIONS.LOCATION.GRANTED) {
				onSuccess({ lat: MobileApplication.userLocation.latitude, long: MobileApplication.userLocation.longitude })
			}
		}

		if (isFirstRender.current && MobileApplication.userLocationPermissionStatus === CONSTANTS.MOBILE_APP.PERMISSIONS.LOCATION.DENIED) {
			isFirstRender.current = false
			return
		}

		if (isMobileApp() && MobileApplication.userLocationPermissionStatus !== CONSTANTS.MOBILE_APP.PERMISSIONS.LOCATION.NOT_ASKED) {
			handleUserLocationPermissionResponse()
		}

		isFirstRender.current = false
	}, [MobileApplication.userLocationPermissionStatus])
}
